import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id A960C38F-7EFE-4FE6-94AB-C7B0CD07DD50
 * name signal-hspa
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/signal-hspa.svg
 * tags
 * - Cellphone / Phone 
 */
export const SignalHspaIcon = createSvgIcon(<><path d="M10.5,10.5H13.5V4.5H16.5V19.5H13.5V13.5H10.5V19.5H7.5V4.5H10.5V10.5Z" /></>, 'SignalHspaIcon');
export default SignalHspaIcon